module.exports = __webpack_public_path__ + "static/img/Aions_Mar_6.347b06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_6.png
// module id = 2KWY
// module chunks = 19